module.exports = __webpack_public_path__ + "img/header_mob.80b6a82.jpg";